import LocalizedStrings from "react-localization";
import en from "./en";
import fr from "./fr";
let strings = new LocalizedStrings({
  fr: fr,
  en: en,
});

export default strings;
